export const REGISTRAR_ACTION = 'REGISTRAR';
export const EDITAR_ACTION = 'EDITAR';
export const UNDEFINED_ACTION = 'UNDEFINED';
